import { render, staticRenderFns } from "./PastTicket.vue?vue&type=template&id=d28c80e2&"
import script from "./PastTicket.vue?vue&type=script&lang=js&"
export * from "./PastTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports